import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

export const schema = {
  type: 'object',
  properties: {
    email: {
      title: 'email',
      type: 'string',
      placeholder: 'emailPlaceholder'
    },
    logo: {
      title: 'logo',
      type: 'string',
      placeholder: 'logoPlaceholder'
    },
    phoneNumber: {
      title: 'phoneNumber',
      type: 'string',
      placeholder: 'phoneNumberPlaceholder'
    },
    address: {
      title: 'address',
      type: 'string',
      placeholder: 'addressPlaceholder'
    },
    trackingInfo: {
      title: 'trackingInfo',
      type: 'boolean'
    }
  }
};

export const uiSchema = {
  'ui:rootFieldId': 'form-roles',
  email: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  logo: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  phoneNumber: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  address: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  trackingInfo: {
    classNames: 'form-control-parent'
  }
};

export const translateSchema = (inputSchema) => {
  function translateProperties (inputProperties) {
    const outputProperties = inputProperties;
    const keys = Object.keys(inputProperties);
    for (let i = 0; i < keys.length; i++) {
      if (inputProperties[keys[i]].title) outputProperties[keys[i]].title = funcTranslateHelper(`Builder:Settings:form:${inputProperties[keys[i]].title}`);
      if (inputProperties[keys[i]].placeholder) outputProperties[keys[i]].placeholder = funcTranslateHelper(`Builder:Settings:form:${inputProperties[keys[i]].placeholder}`);
    }

    return outputProperties;
  }

  inputSchema.properties = translateProperties(inputSchema.properties);
}
;
